import script from "./ProjectWorkReporting.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectWorkReporting.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectWorkReporting.vue?vue&type=style&index=0&id=8771d30c&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8771d30c"]])

export default __exports__